/**
 * Global Clerk token provider for legacy API utilities
 * 
 * This allows create-endpoint.ts to access Clerk tokens without requiring
 * hook-based architecture changes across all API calls.
 */

type TokenGetter = (options?: { template?: string }) => Promise<string | null>

let globalTokenGetter: TokenGetter | null = null

export function setClerkTokenGetter(getter: TokenGetter) {
  globalTokenGetter = getter
}

export function getClerkTokenGetter(): TokenGetter | null {
  return globalTokenGetter
}
